import { render, staticRenderFns } from "./Studio.vue?vue&type=template&id=356b8594&scoped=true"
import script from "./Studio.vue?vue&type=script&lang=js"
export * from "./Studio.vue?vue&type=script&lang=js"
import style0 from "./Studio.vue?vue&type=style&index=0&id=356b8594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356b8594",
  null
  
)

export default component.exports